import React from 'react'


const Boolean = ({value}) => {
    return value ? "Yes" : "No"
}

export default Boolean